import { tv } from 'tailwind-variants';

/** Shared chrome for enterprise header pills (language, logout). */
export const enterpriseHeaderPill = tv({
  base: [
    'inline-flex items-center rounded-full border border-[var(--color-rail-card-border)]',
    'bg-[var(--color-an-surface-muted)] px-3 py-1 text-xs font-medium text-[var(--color-an-text)]',
  ].join(' '),
  variants: {
    pressed: {
      true: 'border-[var(--color-an-border-hover)] bg-[var(--color-an-surface)] text-[var(--color-an-text)]',
      false: '',
    },
    interactive: {
      true: 'cursor-pointer hover:bg-[var(--color-an-surface)]',
      false: '',
    },
  },
  defaultVariants: {
    pressed: false,
    interactive: false,
  },
});
